/**
 *
 * Handles all system area information API calls
 * @author Kyle Ellman
 *
 */
import { getV2Resource, vkApiInstance } from "apis/vk";
import { waitForJobToFinish } from "apis/vk/jobs";

const getBaseUrl = systemId => `/v2/panels/${systemId}/system_area_information`;

/**
 * Fetches system area information
 * @param  {integer} systemId
 * @param  {boolean} refresh (optional)
 * @return {promise}
 */
export const get = ({ systemId, refresh }) =>
  getV2Resource({
    baseUrl: getBaseUrl(systemId),
    refresh
  });

/**
 * updates system area information
 * @param  {integer} systemId
 * @param  {object} systemAreaInformation
 * @return {promise}
 */
export const update = ({ systemId, systemAreaInformation }) =>
  waitForJobToFinish(
    vkApiInstance.put(getBaseUrl(systemId), {
      system_area_information: systemAreaInformation
    })
  );
